import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService, BaseDataService, ConfigService, DefaultListModalComponent, NotificationService } from 'yt-ng-framework';
import { Drzava } from './drzava';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Country } from './country';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'yt-drzava',
  templateUrl: './drzava.component.html'
})
export class DrzavaComponent extends BaseModalContainer<Drzava> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Drzava>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService,
    protected httpClient: HttpClient,
    protected baseDataService: BaseDataService,
    protected configService: ConfigService,
    // protected notificationService: NotificationsService
    protected toastrService: NotificationService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  loadingCompanyData:boolean = false;
  // API_URL = "http://restcountries.eu/rest/v2";
  API_URL = "https://restcountries.com/v2";
  country: Country;
  // @Input() ShowLoader: boolean = false;

  @ViewChild('defaultList', { static: true }) defaultList: DefaultListModalComponent<Drzava>;

  ngOnInit() {
  }
  
   GetCountryData(){
    // this.ShowLoader = true;
    this.httpClient.get(`${this.API_URL}/all`)
    .subscribe((data: Country[]) =>{
      // this.ShowLoader = true;
      if(!data || data.length == 0){
        alert('Ne postoje podaci za države');
        return;
      }

      // var mapped = data.map(item => ({ "alpha3Code": item.alpha3Code, "name" : item.name }) );
      // var newObj = Object.assign({}, ...mapped );
     
      // let brojNovih:number = 0;
      // let brojPostojecih:number = 0;
      data.forEach(element => {        
        this.country = new Country().Deserialize(element);
        let naziv = this.country.translations['hr'];
        
        switch(naziv){
          case 'Njemačka':
           naziv = 'Nemačka';
           break;
          case 'Rumunjska': 
            naziv = 'Rumunija';
            break;
          case 'Španjolska': 
            naziv = 'Španija';
            break;
          case 'Nizozemska': 
            naziv = 'Holandija';
            break;
          case 'Švicarska': 
            naziv = 'Švajcarska';
            break;
        }
        let parameters = {Naziv: naziv, ISOAlpha2Code: this.country.alpha2Code, ISOAlpha3Code: this.country.alpha3Code, ISONumericCode: this.country.numericCode};
        this.baseDataService.Post('drzava','SaveFromRestCountries', parameters, null)
          .subscribe(() => {

          }
            // dodato => {
            // if(dodato)
            //  brojNovih=brojNovih++;
            // else
            //   brojPostojecih=brojPostojecih++;
              
            //  this.notificationService.success();
            // }
         , error => {
            // this.notificationService.error("Greška kod uvoza","Došlo je do greške.");
        });
      }); 
      this.defaultList.LoadMainItems(true, this.defaultList.filterComponent ? this.defaultList.filterComponent.filterFormGroup.value : null);
      alert("Uvoz država je završen.");     
      // this.ShowLoader = false;
      
    });
   
    
  }
}
